/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

// Product discount signup box (snippets/product-discount-code.liquid).
// The box stays visible until the visitor completes the discount signup:
// email only (CZ), or email followed by SMS (PL, data-klaviyo-requires-sms).
// Only explicit signups count; generic Klaviyo identity data (__kl_key,
// __kla_id) is present for anonymous visitors too and must not hide the box.
(function () {
	var OWN_FLAG = "gl_klaviyo_subscribed";
	var HIDE_SELECTOR = "[data-klaviyo-subscriber-hide]";

	// Returns { formId: requiresSms } for discount forms rendered on the page
	function getDiscountForms() {
		var forms = {};
		document.querySelectorAll(HIDE_SELECTOR + " [data-klaviyo-form-id]").forEach(function (el) {
			var id = el.getAttribute("data-klaviyo-form-id");
			if (id) forms[id] = el.hasAttribute("data-klaviyo-requires-sms");
		});
		return forms;
	}

	function setDiscountSignupVisible(visible) {
		document.querySelectorAll(HIDE_SELECTOR).forEach(function (el) {
			el.style.display = visible ? "" : "none";
		});
	}

	function hasCompletedSignup() {
		// 1. Our own persistent flag (survives cookie consent changes)
		try {
			if (localStorage.getItem(OWN_FLAG)) return true;
		} catch (e) {}
		// 2. Klaviyo's sessionStorage record of completed forms. A multi-step form
		// lands here after its first (email) submit, so it only proves completion
		// for forms without an SMS step.
		try {
			var stored = sessionStorage.getItem("klaviyoFormSubmit");
			if (stored) {
				var data = JSON.parse(stored);
				if (data.completedForms) {
					var forms = getDiscountForms();
					for (var id in forms) {
						if (!forms[id] && id in data.completedForms) {
							localStorage.setItem(OWN_FLAG, "1");
							return true;
						}
					}
				}
			}
		} catch (e) {}
		return false;
	}

	if (!hasCompletedSignup()) {
		setDiscountSignupVisible(true);
	}

	// Klaviyo form events: submit/stepSubmit carry the submitted fields in
	// detail.metaData (email, phone_number). Mark the signup complete once the
	// required contact is submitted and hide the box when the popup closes.
	window.addEventListener("klaviyoForms", function (e) {
		var detail = e.detail || {};
		var forms = getDiscountForms();
		if (!detail.formId || !(detail.formId in forms)) return;

		if (detail.type === "submit" || detail.type === "stepSubmit") {
			var meta = detail.metaData || {};
			var hasPhone = !!(meta.phone_number || meta.$phone_number);
			var hasEmail = !!(meta.email || meta.$email);
			if (hasPhone || (hasEmail && !forms[detail.formId])) {
				try {
					localStorage.setItem(OWN_FLAG, "1");
				} catch (err) {}
			}
		} else if (detail.type === "close") {
			if (hasCompletedSignup()) setDiscountSignupVisible(false);
		}
	});
})();

(function () {
	document.addEventListener("click", function (e) {
		var trigger = e.target.closest("[data-klaviyo-form-trigger]");
		if (!trigger) return;

		e.preventDefault();

		var formId = trigger.getAttribute("data-klaviyo-form-id");
		if (!formId) return;

		window._klOnsite = window._klOnsite || [];

		if (window._klOnsite && typeof window._klOnsite.openForm === "function") {
			window._klOnsite.openForm(formId);
			return;
		}

		window._klOnsite.push(["openForm", formId]);
	});

	// Show more / Show less toggle for sidebar filters
	document.addEventListener(
		"click",
		function (e) {
			var button = e.target.closest("[data-show-more]");
			if (!button) return;

			e.stopPropagation();

			var isExpanded = button.getAttribute("data-expanded") === "true";
			var container = button.previousElementSibling;

			if (!container) return;

			if (isExpanded) {
				// Collapse: re-hide items beyond the visible limit
				var items = container.querySelectorAll(".sidebar__item, .filter__button");
				items.forEach(function (item, index) {
					if (index >= 10) {
						item.classList.add("is-hidden");
					}
				});
				button.textContent = button.getAttribute("data-show-more-text");
				button.setAttribute("data-expanded", "false");
			} else {
				// Expand: show all hidden items
				container.querySelectorAll(".is-hidden").forEach(function (item) {
					item.classList.remove("is-hidden");
				});
				button.textContent = button.getAttribute("data-show-less-text");
				button.setAttribute("data-expanded", "true");
			}
		},
		true,
	); // capture phase to intercept before theme.js
})();

// Refresh AOS after all images/content load so scroll positions are accurate
window.addEventListener('load', function () {
	if (themeVendor && themeVendor.AOS) {
		themeVendor.AOS.refresh();
	}
});

// --- Equal carousel cell heights ---
// Flickity computes viewport height before CSS aspect-ratio settles and before
// AJAX sections (recommendations, recently viewed) load.  Fix: temporarily
// un-constrain cells, measure natural heights, then update the viewport.
// The CSS height:100% rule in product-card-redesign.css stretches shorter
// cells to match.
(function () {
	function equalizeCarousel(vp) {
		var cells = vp.querySelectorAll('.product-grid-slide, .slide-item');
		if (!cells.length) return;

		// Remove constraints so cells assume natural content height
		// Use setProperty with !important to override the CSS !important rule
		// in product-card-redesign.css (.flickity-viewport .slide-item { height: 100% !important })
		for (var i = 0; i < cells.length; i++) {
			cells[i].style.setProperty('height', 'auto', 'important');
			cells[i].style.bottom = 'auto';
		}

		// Find the tallest cell
		var max = 0;
		for (var i = 0; i < cells.length; i++) {
			if (cells[i].scrollHeight > max) max = cells[i].scrollHeight;
		}

		// Update viewport and clear inline overrides (CSS height:100% takes over)
		if (max > 0) vp.style.height = max + 'px';
		for (var i = 0; i < cells.length; i++) {
			cells[i].style.height = '';
			cells[i].style.bottom = '';
		}
	}

	function equalizeAll() {
		document.querySelectorAll('.flickity-viewport').forEach(equalizeCarousel);
	}

	window.addEventListener('load', equalizeAll);
	document.addEventListener('theme:resize', equalizeAll);

	// Watch for AJAX-loaded carousels (recommendations, recently viewed)
	new MutationObserver(function (mutations) {
		for (var i = 0; i < mutations.length; i++) {
			for (var j = 0; j < mutations[i].addedNodes.length; j++) {
				var node = mutations[i].addedNodes[j];
				if (node.nodeType !== 1) continue;
				var viewports = node.querySelectorAll
					? node.querySelectorAll('.flickity-viewport')
					: [];
				if (node.classList && node.classList.contains('flickity-viewport')) {
					equalizeCarousel(node);
				}
				viewports.forEach(equalizeCarousel);
			}
		}
	}).observe(document.body, { childList: true, subtree: true });
})();

// (function() {

//   // Below are example event listeners.  They listen for theme events that Pipeline
//   // fires in order to make it easier for you to add customizations.

//   // Keep your scripts inside this IIFE function call to avoid leaking your
//   // variables into the global scope.

//   document.addEventListener('theme:variant:change', function(event) {
//     // You might use something like this to write a pre-order feature or a
//     // custom swatch feature.
//     var variant = event.detail.variant;
//     var container = event.target;
//     if (variant) {
//       console.log('Container ———————— ↓');
//       console.log(container);
//       console.log('Variant —————————— ↓');
//       console.log(variant);
//       // ... update some element on the page
//     }
//   });

//   document.addEventListener('theme:cart:change', function(event) {
//     var cart = event.detail.cart;
//     if (cart) {
//       console.log('Cart ———————————— ↓');
//       console.log(cart);
//       // ... update an app or a custom shipping caluclator
//     }
//   });
//   // Fired when page loads to update header values
//   document.addEventListener('theme:cart:init', (e) => {
//     console.log('theme:cart:init');
//     console.log(e);
//   });

//   // Debounced scroll listeners.  Up and down only fire on direction changes
//   // These events are useful for creating sticky elements and popups.
//   document.addEventListener('theme:scroll', e => { console.log(e); });
//   document.addEventListener('theme:scroll:up', e => { console.log(e); });
//   document.addEventListener('theme:scroll:down', e => { console.log(e); });

//   // Debounced resize listener to bundle changes that trigger document reflow
//   document.addEventListener('theme:resize', e => { console.log(e); });

//   // Locks and unlocks page scroll for modals and drawers
//   // These are commented out because firing them will lock the page scroll
//   // the lock event must set `detail` to the modal or drawer body so the
//   // scroll locking code knows what element should maintain scoll.
//   // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
//   // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

//   // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
//   // variables into the global scope.
// // })();


// --- Price info tooltip arrow positioning ---
// The tooltip is positioned from the price row but the arrow must point at the
// (i) icon.  Set a CSS variable so the arrow tracks the icon's offset.
document.addEventListener('mouseenter', function (e) {
	if (!e.target.closest) return; // capture also fires for document/text targets
	var info = e.target.closest('.pc-price-info');
	if (!info) return;
	var tooltip = info.querySelector('.pc-price-info__tooltip');
	var priceRow = info.closest('.product__grid__price');
	if (!tooltip || !priceRow) return;
	var btn = info.querySelector('.pc-price-info__button');
	var btnRect = btn.getBoundingClientRect();
	var rowRect = priceRow.getBoundingClientRect();
	var offset = btnRect.left + btnRect.width / 2 - rowRect.left;
	tooltip.style.setProperty('--arrow-left', offset + 'px');
}, true);

// --- Product Card Size Picker ---
// Truncation is fully CSS + Liquid (no layout shift).
// JS handles: size selection, +N → quickview, ATC-without-selection → quickview.
(function () {
	// Size button click: toggle selection, update ATC variant input & price
	document.addEventListener('click', function (e) {
		var btn = e.target.closest('.pc-sizes__btn');
		if (!btn) return;

		var grid = btn.closest('[data-pc-sizes-grid]');
		if (!grid) return;

		var wasSelected = btn.classList.contains('is-selected');

		// Deselect all in this grid
		grid.querySelectorAll('.pc-sizes__btn').forEach(function (b) {
			b.classList.remove('is-selected');
		});

		// Toggle
		if (!wasSelected) {
			btn.classList.add('is-selected');
		}

		// Update the ATC form hidden variant input
		var card = btn.closest('.product-grid-item') || btn.closest('.slide-item');
		if (!card) return;

		var variantInput = card.querySelector('[data-pc-atc-variant-id]');
		if (variantInput) {
			variantInput.value = wasSelected ? '' : btn.getAttribute('data-variant-id');
		}

		// Update displayed price
		var priceContainer = card.querySelector('[data-pc-price-container]');
		if (!priceContainer) return;

		var priceEl = priceContainer.querySelector('.price');
		var compareEl = priceContainer.querySelector('.compare-at');

		if (wasSelected) {
			// Deselected — revert to original product price
			if (priceEl) {
				priceEl.innerHTML = priceContainer.getAttribute('data-original-price');
				if (priceContainer.getAttribute('data-original-on-sale') === 'true') {
					priceEl.classList.add('on-sale');
				} else {
					priceEl.classList.remove('on-sale');
				}
			}
			if (compareEl) {
				var origCompare = priceContainer.getAttribute('data-original-compare-price');
				if (origCompare) {
					compareEl.innerHTML = origCompare;
					compareEl.style.display = '';
				} else {
					compareEl.style.display = 'none';
				}
			}
		} else {
			// Selected — show variant price
			var variantPrice = btn.getAttribute('data-variant-price');
			var variantComparePrice = btn.getAttribute('data-variant-compare-price');

			if (priceEl && variantPrice) {
				priceEl.innerHTML = variantPrice;
				if (variantComparePrice) {
					priceEl.classList.add('on-sale');
				} else {
					priceEl.classList.remove('on-sale');
				}
			}
			if (compareEl) {
				if (variantComparePrice) {
					compareEl.innerHTML = variantComparePrice;
					compareEl.style.display = '';
				} else {
					compareEl.style.display = 'none';
				}
			}
		}
	});

	// +N button click: open quickview drawer
	document.addEventListener('click', function (e) {
		var moreBtn = e.target.closest('[data-pc-size-toggle]');
		if (!moreBtn) return;

		var sizesContainer = moreBtn.closest('[data-pc-sizes]');
		if (!sizesContainer) return;

		var qvTrigger = sizesContainer.querySelector('[data-pc-qv-trigger]');
		if (qvTrigger) qvTrigger.click();
	});

	// ATC without selection: open quickview drawer instead of submitting
	document.addEventListener('click', function (e) {
		var atcBtn = e.target.closest('.pc-atc__btn');
		if (!atcBtn) return;

		var card = atcBtn.closest('.product-grid-item') || atcBtn.closest('.slide-item');
		if (!card) return;

		// Check if a size is selected in the picker
		var sizeGrid = card.querySelector('[data-pc-sizes-grid]');
		var hasSelectedSize = sizeGrid && sizeGrid.querySelector('.pc-sizes__btn.is-selected');

		// If there's a size picker but no selection, open quickview instead
		if (sizeGrid && !hasSelectedSize) {
			e.preventDefault();
			e.stopPropagation();

			var qvTrigger = card.querySelector('[data-pc-qv-trigger]');
			if (qvTrigger) qvTrigger.click();
		}
	}, true); // capture phase to intercept before Alpine's handler

})();
